import { Award } from "../../types";

export const levelByStars: Record<number, number> = {
  1: 0,
  2: 100,
  3: 300,
  4: 600,
  5: 1000,
  6: 1500,
};

export const getLevelFromStars = (stars?: number) => {
  if (!stars) {
    return 1;
  }
  if (stars < levelByStars[2]) return 1;
  if (stars < levelByStars[3]) return 2;
  if (stars < levelByStars[4]) return 3;
  if (stars < levelByStars[5]) return 4;
  if (stars < levelByStars[6]) return 5;
  return 5;
};

export const getStarsToNext = (stars?: number) => {
  if (!stars) {
    return 0;
  }
  const currLevel = getLevelFromStars(stars);
  return (levelByStars?.[currLevel + 1] || stars) - stars;
};

export const getStarsFromAwards = (awards: Award[]) => {
  return awards.reduce((total, aw) => total + aw.stars, 0);
};
